import React, {Component} from 'react'
import {getLoginInfo, getProfileMenuItems, getYettelMenuItems} from "../../helpers/loginInfo";
import Language from './Language'
import SearchInput from './SearchInput'
import List from './List'
import ActionItem from './ActionItem'
import YettelMenuItem from './YettelMenuItem';
import cart from './img/cart.png'
import search from './img/search.png'
import cardWithOrderItems from './img/cart-with-order-items.png'
import suitcase from './img/suitcase.png'
import ENV from '../../env'
import PropTypes from 'prop-types'
import SendToTnAccountContainer from "../../auth/SendToTnAccount";
import HeaderProfilePopup from "./headerProfilePopup";
import { getLanguageFromUrl, getSectionFromUrl } from '../../helpers/util';
import './css/scss/header.scss'

class DesktopHeader extends Component {
  constructor(props) {
    super(props)
    this.state = {
      activeItemSecondLevelMenu: 0,
      activeItemThirdLevelMenu: 0,
      showLogin: false,
      showSearch: false,
    }
  }

  toggleLogin = () => {
    this.setState({activeItemSecondLevelMenu: 0})
    const currentState = this.state.showLogin
    this.setState({showLogin: !currentState})
  }

  showSearch = () => {
    this.setState({showSearchInput: true})
  }

  hideSearch = () => {
    this.setState({showSearchInput: false})
  }

  handleItemClick = (listLevelId, e) => {
    this.setState({showLogin: false})
    const key = 'activeItem' + listLevelId

    if (key === 'activeItemFirstLevelMenu') {
      this.props.handleItemClick(listLevelId, e)
    } else {
      this.state.activeItemSecondLevelMenu === e.target.id ? this.setState({[key]: 0}) : this.setState({[key]: e.target.id})
    }
  }

  render() {
    const labels = require(`../../trans/${this.props.language}`)
    const header = this.props.pageShell.data.header;
    const consumer = header.consumer;
    const business = header.business;
    const about = header.about;
    const bank = header.bank;
    const menu = [consumer, business, bank, about];
    const loginInfo = this.props.session;
    const loginLinks = getLoginInfo(loginInfo.user, labels);
    const isLoggedIn = Boolean(loginInfo.user);
    const yettelMenuItems = getYettelMenuItems();
    const profileMenuItems = getProfileMenuItems();
    const isConsumer = getSectionFromUrl() === "consumer";
    const language = getLanguageFromUrl();

    const numberOfOrderItems = loginInfo.numberOfOrderItems;

    const activeItemFirstLevelMenu = this.props.activeItemFirstLevelMenu.toString();
    const cartUrl = ENV.root_path + ENV.webshop_path + '/' + this.props.language + '/Privatni-korisnici/Kupovina';
    const businessPortalUrl = 'https://www.yettel.rs/biznisportal/';

    return (
      <div id="desktop-menu">
        <div className='d-flex'>
          <div className='offset-3 col-9 text-right first-level-row header-pr'>
            <List list={menu} handleItemClick={(e) => this.handleItemClick('FirstLevelMenu', e)}
                  activeItem={activeItemFirstLevelMenu} level={'first-level'}/>
            {isConsumer && language === "sr" && (
              <a
                style={{ color: '#002340' }}
                className="no-child list-item first-level yettel-light-font"
                href="https://www.yettel.rs/sr/privatni/podrska"
              >
                <span>| Kontakt i Podrška |</span>
              </a>
            )}
            <Language activeLanguage={this.props.language}/>
          </div>
        </div>
        {this.state.showSearchInput  ?
          <SearchInput handleSearchClose={this.hideSearch} language={this.props.language}
                       section={this.props.section}/> :
          <div className="position-relative">
            <div className='d-flex pb-1'>
              <div className='col-2 pl-4 my-auto'>
                <a href='https://www.yettel.rs/' className="logo-link">
                  <span className="yettel-bold-font">Yettel.</span>
                </a>
              </div>
              <div className='col-6 text-left d-flex align-items-center yettel-font'>
                <List list={menu.find(obj => obj.id.toString() === activeItemFirstLevelMenu).items}
                      handleItemClick={(e) => this.handleItemClick('SecondLevelMenu', e)}
                      activeItem={this.state.activeItemSecondLevelMenu} level='second-level'/>
              </div>

              <div className='col-4 text-right my-auto right-section-menu header-pr'>
                <div className='row'>
                  <div className='col d-flex justify-content-end align-items-center'>
                    <ActionItem alt="search" src={search} handleClick={this.showSearch}/>
                    {this.props.section === 'consumer' &&
                      <React.Fragment>
                        <a href={cartUrl}>
                          {numberOfOrderItems > 0 ?
                            (<ActionItem alt="Cart with order items" src={cardWithOrderItems} title=''/>) :
                            (<ActionItem alt="Cart" src={cart} title=''/>)
                          }
                        </a>
                        <span className='list-item'>
                          <YettelMenuItem yettelMenuItems={yettelMenuItems} />
                        </span>
                        {!isLoggedIn ?
                          <SendToTnAccountContainer setShouldCallLogin={this.props.setShouldCallLogin} cookie={this.props.cookie} from={window.location.href} isTextVisible={true} client={this.props.client}/>
                          :
                          <>
                          <div style={{ width: 0, visibility: "hidden"}}>
                            <SendToTnAccountContainer setShouldCallLogin={this.props.setShouldCallLogin} cookie={this.props.cookie} from={window.location.href} isTextVisible={true} client={this.props.client}/>
                          </div>
                          <HeaderProfilePopup item={profileMenuItems}/>
                          </>
                        }
                      </React.Fragment>
                    }
                    {this.props.section === 'business' &&
                      <a href={businessPortalUrl}>
                        <ActionItem alt="Business portal" src={suitcase} title={labels.businessPortal}/>
                      </a>
                    }
                  </div>
                </div>
              </div>
            </div>

            {this.state.showLogin ?
              <div className='row shadow-border secondary-menu-bar'>
                <div className='col-12 text-right pr-5'>
                  <List list={loginLinks} activeItem={this.state.showLogin}/>
                </div>
              </div> :
              <React.Fragment>
                {(this.state.activeItemSecondLevelMenu !== 0 && menu.find(obj => obj.id.toString() === activeItemFirstLevelMenu).items.find(obj => obj.id.toString() === this.state.activeItemSecondLevelMenu.toString()).items.length) &&
                  <div className='row shadow-border secondary-menu-bar'>
                    <div className='offset-2 col text-left'>
                      <List
                        list={menu.find(obj => obj.id.toString() === activeItemFirstLevelMenu).items.find(obj => obj.id.toString() === this.state.activeItemSecondLevelMenu.toString()).items}
                        handleItemClick={(e) => this.handleItemClick('ThirdLevelMenu', e)}
                        activeItem={this.state.activeItemThirdLevelMenu} level='third-level'/>
                    </div>
                  </div>
                }
              </React.Fragment>
            }
          </div>
        }
      </div>
    )
  }
}

DesktopHeader.propTypes = {
  language: PropTypes.string.isRequired,
  section: PropTypes.string.isRequired,
  pageShell: PropTypes.object.isRequired,
  cookie: PropTypes.object.isRequired,
  session: PropTypes.object.isRequired,
  client: PropTypes.object.isRequired,
  setShouldCallLogin: PropTypes.func.isRequired
}

export default DesktopHeader
